"use strict";

require("lazysizes/plugins/object-fit/ls.object-fit");

require("lazysizes/plugins/parent-fit/ls.parent-fit");

require("lazysizes/plugins/rias/ls.rias");

require("lazysizes/plugins/bgset/ls.bgset");

require("lazysizes");

require("lazysizes/plugins/respimg/ls.respimg");

require("../../styles/theme.scss");

require("../../styles/theme.scss.liquid");

var _themeA11y = require("@shopify/theme-a11y");

var _util = require("../util/util");

var _bodyScrollLock = require("body-scroll-lock");

var _placeHeaderBehindNav = require("../components/placeHeaderBehindNav");

var _toggleNavMenus = require("../components/toggleNavMenus");

var _transitions = require("../components/transitions");

var _transitions2 = _interopRequireDefault(_transitions);

var _animations = require("../components/animations");

var _vanillaJsDropdown = require("vanilla-js-dropdown");

var _vanillaJsDropdown2 = _interopRequireDefault(_vanillaJsDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

(0, _transitions2.default)();

// Apply a specific class to the html element for browser support of cookies.
if ((0, _util.cookiesEnabled)()) {
  document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies");
}

function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }

  // Custom sort select on events blog
  var sortEventsTagsSelect = document.getElementById("events-tags");
  if (sortEventsTagsSelect) {
    var sortEventsTags = new _vanillaJsDropdown2.default({
      elem: sortEventsTagsSelect
    });
  }

  // Custom sort select on accolades
  var varietySelect = document.getElementById("variety-filter");
  if (varietySelect) {
    var varietySelectMenu = new _vanillaJsDropdown2.default({
      elem: varietySelect
    });
  }
  var nameSelect = document.getElementById("name-filter");
  if (nameSelect) {
    var nameSelectMenu = new _vanillaJsDropdown2.default({
      elem: nameSelect
    });
  }
}

function checkForAge() {
  if (window.localStorage.getItem("age-checked")) {
    return;
  }

  var ageCheckEl = document.querySelector(".age-checker__container");
  if (ageCheckEl) {
    setTimeout(function () {
      ageCheckEl.classList.add("active");
      (0, _bodyScrollLock.disableBodyScroll)(ageCheckEl);
    }, 1000);
  }

  var ageCheckBtn = document.querySelector("[data-age-check]");
  if (ageCheckBtn) {
    ageCheckBtn.addEventListener("click", function () {
      if (ageCheckEl) {
        ageCheckEl.classList.remove("active");
        window.localStorage.setItem("age-checked", true);
        (0, _bodyScrollLock.clearAllBodyScrollLocks)();
      }
    });
  }
}

docReady(function () {
  (0, _placeHeaderBehindNav.placeHeaderBehindNav)();
  (0, _toggleNavMenus.setUpMenu)();
  (0, _animations.Animations)();
  checkForAge();
});

window.addEventListener("resize", function (event) {
  // do stuff here
  var windowWidth = event.target.innerWidth;

  if (windowWidth > 1200) {
    var body = document.querySelector("body");
    body.classList.remove("mainNavIsOpen");
    body.classList.remove("subMenuIsOpen");
  }
});

var links = document.querySelectorAll(".smooth");

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var link = _step.value;

    link.addEventListener("click", clickHandler);
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

function clickHandler(e) {
  e.preventDefault();
  var href = this.getAttribute("href");
  var offsetTop = document.querySelector(href).offsetTop;

  scroll({
    top: offsetTop,
    behavior: "smooth"
  });
}